import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import Quote from "./pages/Quote";
import Scan from "./pages/Scan";
import ClearancePage from "./pages/ClearancePage";
import ThankYouUmzug from "./pages/ThankYouUmzug";
import ThankYouEntruempelung from "./pages/ThankYouEntruempelung";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminCMS from "./pages/AdminCMS";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import StickyScanCTA from "./components/StickyScanCTA";
import StickyWhatsAppCTA from "./components/StickyWhatsAppCTA";
import PixelManager from "./components/PixelManager";
import { CmsProvider } from "./lib/cms";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <CmsProvider>
        <BrowserRouter>
          <PixelManager />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/angebot" element={<Quote />} />
            <Route path="/entruempelung" element={<ClearancePage />} />
            <Route path="/danke-umzug" element={<ThankYouUmzug />} />
            <Route path="/danke-entruempelung" element={<ThankYouEntruempelung />} />
            <Route path="/scan" element={<Scan />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/cms" element={<AdminCMS />} />
          </Routes>
          <StickyScanCTA />
          <StickyWhatsAppCTA />
        </BrowserRouter>
      </CmsProvider>
    </div>
  );
}

export default App;
